import script from "./project-grid-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./project-grid-modal.vue?vue&type=script&setup=true&lang=js"

import "./project-grid-modal.vue?vue&type=style&index=0&id=565b690c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565b690c"]])

export default __exports__